module.exports = __webpack_public_path__ + "media/icons/szkody-pojazdu-white-6056a1ce.png";